<template>
  <div class="dflexc-jcs blog-admin-panel">
    <h1 class="data-entry">Topics</h1>
    <div class="dflexc-jcs data-entry-form">
      <div class="dflexr-jcsa form-row">
        <div class="input-group">
          <label>Title</label>
          <input v-model="form.title" />
        </div>
        <div class="input-group">
          <label>Slug</label>
          <input v-model="form.slug" />
        </div>
      </div>
      <div class="input-group">
        <label>Description</label>
        <textarea v-model="form.description" rows="2" />
      </div>
      <div class="dflexr-jcsa form-row">
        <div class="input-group">
          <label>Link path</label>
          <input v-model="form.link_path" placeholder="/EmpireWargames" />
        </div>
        <div class="input-group" style="flex: 0 0 6rem;">
          <label>Position</label>
          <input type="number" v-model.number="form.position" />
        </div>
        <div class="input-group" style="flex: 0 0 6rem;">
          <label>Published</label>
          <input type="checkbox" v-model="form.published" />
        </div>
      </div>
      <div class="dflexr-jcsb data-entry-action-row">
        <div class="dflexr-jcs">
          <BtnCommon btnLabel="Add" styleclass="action-btn-add"
                     :isDisabled="!canAdd" @clicked="addTopic" />
          <BtnCommon btnLabel="Save" styleclass="action-btn-save"
                     :isDisabled="!editing" @clicked="saveTopic" />
          <BtnCommon btnLabel="Cancel" styleclass="action-btn-cancel"
                     :isDisabled="!editing && !form.title" @clicked="resetForm" />
        </div>
        <BtnCommon btnLabel="Remove" styleclass="action-btn-remove"
                   :isDisabled="!editing" @clicked="removeTopic" />
      </div>
    </div>
    <div class="list-view">
      <div class="dflexr-jcs list-header">
        <div class="col title">Title</div>
        <div class="col slug">Slug</div>
        <div class="col pub">Pub</div>
        <div class="col act">Actions</div>
      </div>
      <div class="dflexr-jcs list-row" v-for="(t, idx) in topics" :key="t.id"
           :class="{ striped: idx % 2 === 0 }">
        <div class="col title">{{ t.title }}</div>
        <div class="col slug">{{ t.slug }}</div>
        <div class="col pub">{{ t.published ? 'Y' : 'N' }}</div>
        <div class="col act" @click="editTopic(t)">Edit</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeMount, reactive, ref } from "vue";
import BtnCommon from "@/components/common/btn-common.vue";
import { BlogService } from "@/services/blog_service";

const blog = new BlogService();
const topics = ref([]);
const editing = ref(false);
const form = reactive({
  id: null,
  title: "",
  slug: "",
  description: "",
  link_path: "",
  position: 0,
  published: true
});

const canAdd = computed(() => !editing.value && form.title && form.slug);

function resetForm() {
  form.id = null;
  form.title = "";
  form.slug = "";
  form.description = "";
  form.link_path = "";
  form.position = 0;
  form.published = true;
  editing.value = false;
}

async function load() {
  const pkg = await blog.adminListTopics();
  topics.value = pkg.topics || [];
}

function editTopic(t) {
  Object.assign(form, {
    id: t.id,
    title: t.title,
    slug: t.slug,
    description: t.description || "",
    link_path: t.link_path || "",
    position: t.position || 0,
    published: !!t.published
  });
  editing.value = true;
}

async function addTopic() {
  await blog.adminSaveTopic({ ...form, id: null });
  resetForm();
  await load();
}

async function saveTopic() {
  await blog.adminSaveTopic({ ...form });
  resetForm();
  await load();
}

async function removeTopic() {
  if (!form.id) return;
  if (!confirm("Delete topic " + form.title + "?")) return;
  await blog.adminDeleteTopic(form.id);
  resetForm();
  await load();
}

onBeforeMount(load);
</script>

<style scoped lang="scss">
@import "@/assets/styles/admin/user-table-input-form";
@import "@/assets/styles/blog-admin";
</style>
